import React from 'react';
import { Calendar, Scale, TrafficCone, ShieldCheck } from 'lucide-react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
const pillars = [{
  title: 'La Ruta 10 Días',
  desc: 'Una tabla clara con porcentajes día por día. Tú solo sigues el paso, sin pensar.',
  icon: Calendar
}, {
  title: 'Plantilla de Porciones',
  desc: 'Para dejar de adivinar y evitar el error más común: "dar de más / dar de menos".',
  icon: Scale
}, {
  title: 'Semáforo de Popó',
  desc: 'La herramienta que te quita el miedo. Verde, amarillo o rojo: sabrás qué significa.',
  icon: TrafficCone
}, {
  title: 'Plan B (48h) Dieta Suave',
  desc: 'No para que entres en pánico. Para que tengas un plan exacto si algo se desordena.',
  icon: ShieldCheck
}];
export function SystemReveal() {
  return <Section className="bg-cream" data-id="element-133">
      <div className="text-center mb-16" data-id="element-134">
        <span className="text-green font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-135">
          La Solución
        </span>
        <h2 className="text-3xl md:text-5xl font-bold text-navy mb-6" data-id="element-136">
          Presentando: <br className="md:hidden" data-id="element-137" /> Protocolo 10 Días
        </h2>
        <p className="text-lg text-navy/70 max-w-2xl mx-auto" data-id="element-138">
          Un PDF práctico (cero relleno) diseñado para una sola misión: pasarte
          de croquetas a comida real en 10 días con una ruta gradual.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-139">
        {pillars.map((pillar, index) => <Card key={index} delay={index * 0.1} className="relative overflow-hidden group hover:border-green/30 transition-colors" data-id="element-140">
            <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-141">
              <pillar.icon className="w-24 h-24 text-green" data-id="element-142" />
            </div>

            <div className="relative z-10 flex flex-col h-full" data-id="element-143">
              <div className="w-12 h-12 bg-green/10 rounded-xl flex items-center justify-center mb-4 text-green" data-id="element-144">
                <pillar.icon className="w-6 h-6" data-id="element-145" />
              </div>

              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-146">
                {pillar.title}
              </h3>
              <p className="text-navy/70 leading-relaxed" data-id="element-147">{pillar.desc}</p>
            </div>
          </Card>)}
      </div>
    </Section>;
}